export const getRapidViewUrl = (baseUrl: string, sprintId: number | string) =>
	`${baseUrl}/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
